import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { UserContext } from '@app/context/user-context'

class InviteParent extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {
          ({ user }) => user ?
            <Redirect to={{ pathname: "/parents/children/add-child", search: location.search }} /> :
            <Redirect to={{ pathname: "/register/parent/info", search: location.search }} />
        }
      </UserContext.Consumer>
    )
  }
}

export default InviteParent
